import { TrainingSessionAssignment } from './training-session-assignment';
export class TrainingSession {
  id: number;
  name: string;
  trainingSessionAssignmentList: TrainingSessionAssignment[];
  site: number;
}



// WEBPACK FOOTER //
// ./src/app/model/training-session.ts